import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { BriefcaseIcon, MapPinIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Form, useSearchParams } from "@remix-run/react";
import { Input } from "./ui/input";

export default function SearchMenu({ isMobile }: { isMobile: boolean }) {
  const [searchParams] = useSearchParams();

  const title = searchParams.get("t") || undefined;
  const location = searchParams.get("l") || undefined;

  return (
    <div className="flex-1 sticky top-20 pr-4">
      <Form>
        <div className="flex flex-col w-full lg:p-2 space-y-4">
          <div className="flex flex-col gap-2 flex-1 w-full">
            <div className="flex gap-2">
              <BriefcaseIcon /> What
            </div>
            <Input
              name="t"
              defaultValue={title}
              placeholder="Job title, keywords or company"
            />
          </div>

          <div className="flex flex-col gap-2 flex-1 w-full">
            <div className="flex gap-2 ">
              <MapPinIcon /> Where
            </div>
            <Input
              name="l"
              defaultValue={location}
              placeholder="Town or State"
            />
          </div>
          <div>
            <Button className="mt-4 w-full" variant="default" type="submit">
              <MagnifyingGlassIcon className="mr-1 h-6 w-6" /> Search
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
